import { createActions } from 'redux-actions';

import customerActions from './customer/customerActions';
import hotelsActions from './hotels/hotelsActions';
import availActions from './avail/availActions';
import systemActions from '@synergycms_core/store/customer/systemActions'; 
import availCacheActions from '@synergycms_core/store/avail/availCacheActions';
import availCalendarActions from './avail/availCalendarActions';
import availServicesActions from './avail/availServicesActions';
import notificationActions from '@synergycms_core/store/notifications/notificationActions';
import appActions from '@synergycms_core/store/app/appActions';
import eventsActions from './events/eventsActions';
import { Map } from 'immutable';
import storage from '@synergycms_core/utils/storage';
import ParamsParser from '@synergycms_core/utils/paramsParser';
import { langCodeCorrector } from '@synergycms_core/utils/api';
import { VALID_TPV_HASH } from '../config/constants';
import { contains, pipe, map, sortBy, is } from 'ramda';
import api from '@synergycms_core/utils/api';
import moment from 'moment';

//ACTIONS
const actions = createActions({
  APP: appActions,
  CUSTOMER: customerActions,
  HOTELS: hotelsActions,
  AVAIL: availActions,
  AVAIL_CACHE: availCacheActions,
  AVAIL_CALENDAR: availCalendarActions,
  AVAIL_SERVICES: availServicesActions,
  ROUTER: {
    // arrayHash -> es el hash actual de la URL del navegador
    UPDATE: (replace = false) => (dispatch, getState, arrayHash) => {

      // FIXME Esperar l'Edu pel tema de les URLs - de mentres foto la guarrada aquí i em quedo mes ample que en Salva
      if (typeof arrayHash[3] !== 'undefined' && arrayHash[3].indexOf('access_token') !== -1) {
        let accessToken = arrayHash[3].split('&')[1].split('=')[1];
        console.log(arrayHash[3].split('&')[3].split('=')[1]);
        let expiresIn = moment().add((arrayHash[3].split('&')[3].split('=')[1]) - (10 * 60), 'seconds');
        storage.setLocal('amazon_access_token', decodeURI(accessToken));
        storage.setLocal('amazon_access_token_expire', expiresIn);
      }

      const store = getState();
      const newHash = [];

      newHash[0] = store.getIn(['customer', 'step', 'current_step', 'code']);
      newHash[1] = store.getIn(['customer', 'current_currency']);
      if (contains(newHash[0], ['customerForm', 'confirmation', 'cancelation', 'newCof'])) {
        const reservation = store.getIn(['customer', 'reservation'], Map());
        const trackingId = reservation.get('tracking_id', false);
        newHash[2] = trackingId || '';

        // FIXME Arreglar aquesta super shit quan estigui mes encaminat el tema dels paràmetres a la URL
        if (
          ['customerForm', 'newCof'].includes(newHash[0]) &&
          +newHash[2] > 0 &&
          arrayHash[3] &&
          arrayHash[3].length > 0 &&
          (
              VALID_TPV_HASH.includes(arrayHash[3]) ||
            (
              reservation.getIn(['payment', 'payform_code'], false) === 'amazon_pay' &&
              arrayHash[3].indexOf('AMAZON') !== -1
            )
          )
        ) {
          newHash[3] = arrayHash[3];
        }
      }
      const webType = store.getIn(['customer', 'web_type'], false);
      const hotelId = store.getIn(['customer', 'current_hotel']);
      const urlParams = store.getIn(['customer', 'params', 'url_params']);

      let validRoute = {
        hash: newHash,
        search: ParamsParser.convertParamsToStringQuery(urlParams)
      };

      if (webType !== 'WI' && !contains(store.getIn(['customer', 'step', 'current_step', 'code'], false), ['cancelation', 'newCof'])) {
        const enable_wi_url = (window.frontLoader && window.frontLoader['cms-avail']?.config.enable_wi_url) || window.engine_sygy_data?.enable_wi_url
        let availUrl = (hotelId && !!enable_wi_url)
          ? store.getIn(['hotels', hotelId, 'avail'])
          : store.getIn(['hotels', 'hotels_info', 'availUrl']);

        if (!availUrl || !is(String, availUrl)) {
          availUrl = store.getIn(['hotels', 'hotels_info', 'availUrl']);
        }
        try {
          if (!availUrl || !is(String, availUrl)) {
            availUrl = window.location.origin + '/disponibilidad.html';
          }
          const url = new URL(availUrl);
          document.title = hotelId
            ? document.title.split('-')[0] + ' - ' + store.getIn(['hotels', hotelId, 'name'])
            : document.title.split('-')[0];
          validRoute['pathname'] = url.pathname;
        } catch (error) {
          console.warn('url error : ' + error);
        }
      }

      const oldLastValidUrl = storage.getLocal('last_valid_route');

      storage.setLocal('last_valid_route', validRoute);

      dispatch(actions.customer.loyalty.saveSearch(oldLastValidUrl))

      if (replace) {
        validRoute.action = 'replace';
      }
      return validRoute;
    },
    ERROR: (params = Map()) => (dispatch, getState, arrayHash) => {
      const lastValidRoute = storage.getLocal('last_valid_route');
      if (lastValidRoute) {
        lastValidRoute.action = 'replace';
        return lastValidRoute;
      }
    }
  },
  COUNTRIES: {
    GET: (countries, langInfo) => {
      return pipe(
        map(country => {
          let langCode = langInfo.code.toLowerCase() || 'en';
          langCode = langCodeCorrector(langCode);
          let translations = country.translations[langCode];
          country.name =
            translations === undefined || translations.name === undefined
              ? country.translations['en'].name
              : translations.name;
          return country;
        }),
        sortBy(f => f.name)
      )(countries);
    }
  },
  GROUP: {
    GET: group => {
      return function (dispatch) {
        group && dispatch(actions.groupInfo.getAsync(group));
        return group;
      }
    }
  },
  GROUP_INFO: {
    GET_ASYNC: group => {
      return (dispatch, getState) => {
        const store = getState();
        group = group || store.get("group");

        return api.get({
          path:`group_descriptive/${group}`,
          fullFiled: ()=> getState().get("groupInfo").size && getState().get("groupInfo"),
          store: ({ store, request }) => (store.data = store.data || request())
        }).then(response => {
          return response;
        });
      }
    }
  },
  NOTIFICATIONS: notificationActions,
  EVENTS: eventsActions,
  SYSTEM : systemActions,
  AVAIL_QUERY : {
    SET_MULTI_AVAIL_KEYS : (isLoyalty) => (dispatch, getState) => {
      let prefix = "";
      const store = getState();
      if(store.getIn(['customer', 'corporate', 'tipo_perfil'], false) !== '1' && (isLoyalty || store.getIn(['customer', 'loyalty', 'descriptives', store.get("group"), 'loyalty'], null))) {
        prefix = "loyalty_";
      }
  
      return Map({
        base :`base_string_${prefix}query_params`,
        params :`${prefix}query_params`,
        string_params :`string_${prefix}query_params`,
        params_service :`service_${prefix}query_params`,
        string_service :`string_service_${prefix}query_params`,
        params_calendar :`calendar_${prefix}query_params`,
        string_calendar :`string_calendar_${prefix}query_params`,
        base_params_calendar :`base_calendar_${prefix}query_params`,
        base_string_calendar :`base_string_calendar_${prefix}query_params`,
      });
    },
    SET_MONO_AVAIL_KEYS : (isLoyalty) => (dispatch, getState) => {
      let prefix = "";
      const store = getState();
      if(store.getIn(['customer', 'corporate', 'tipo_perfil'], false) !== '1' && isLoyalty) {
        prefix = "loyalty_";
      }

      return Map({
        base :`base_string_${prefix}query_params`,
        params :`${prefix}query_params`,
        string_params :`string_${prefix}query_params`,
        params_service :`service_${prefix}query_params`,
        string_service :`string_service_${prefix}query_params`,
        params_calendar :`calendar_${prefix}query_params`,
        string_calendar :`string_calendar_${prefix}query_params`,
        base_params_calendar :`base_calendar_${prefix}query_params`,
        base_string_calendar :`base_string_calendar_${prefix}query_params`,
      });
    }
  }
});
export default actions;
